// removed by extract-text-webpack-plugin
module.exports = {"vpTextInputContainer":"vpTextInputContainer___2kq45","vpTextInputLabel":"vpTextInputLabel___1-Bjg","vpCheckError":"vpCheckError___2nmoJ","vpOkNotTouched":"vpOkNotTouched___I84xv","vpOkTouched":"vpOkTouched___2Ng_9","vpCustomInput":"vpCustomInput___2cTc4","vpInvalidField":"vpInvalidField___3kcfs","vpErrorMessage":"vpErrorMessage___1mWPs","vpRequiredLabel":"vpRequiredLabel___1uMAD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/TextInput.module.less
// module id = 3603
// module chunks = 29